// performerに関するstore

import axios from "axios";
import store from '../../store'

import consts from '../../utils/consts'

axios.defaults.headers['X-Requested-With'] = 'XMLHttpRequest';

const state = {
  currentGenre: 'all',
  items: [],
  events: [],
  messages: [],
  musics: [],
  length: -1,
  messagesLength: -1,
  musicLength: -1,
  follow_status: consts.PERFORMER_FOLLOW_STATUS.DEFAULT,
  performerData: {},
  isFollowing: false,
  displayProgress: false,
  isSendingRequest: false
}


const getters = {
  currentGenre: (state) => {
    return state.currentGenre
  },
  events: (state) => {
    return state.items
  },
  eventsForCuration: (state) => {
    return state.events
  },
  length: (state) => {
    return state.length
  },
  follow_status: (state) => {
    return state.follow_status
  },
  performerData: (state) => {
    return state.performerData
  },
  messages: (state) => {
    return state.messages
  },
  messagesLength: (state) => {
    return state.messagesLength
  },
  musics: (state) => {
    return state.musics
  },
  musicLength: (state) => {
    return state.musicLength
  },
  isFollowing: (state) => {
    return state.isFollowing
  },
  displayProgress: (state) => {
    return state.displayProgress
  },
  isSendingRequest: (state) => {
    return state.isSendingRequest
  }
}


const actions = {
  // 出演者に紐づくeventsを取得
  async getEvents ({ commit }, { api_path, p, page, per }) {
    commit('setDisplayProgress', true)
    await axios.get(api_path + '?p=' + p + '&page=' + page + "&per=" + per)
    .then(res => {
      if (res.data.status != consts.API.STATUS_OK ) {
        alert(res.data.message);
        commit('setEventsCount', 0)
        commit('setDisplayProgress', false)
      } else {
        commit('setEvents', res.data.data.data)
        commit('setEventsCount', res.data.data.length)
        commit('setEventsForCuration', res.data.data.data)
        commit('setDisplayProgress', false)
      }
    })
  },

  // 出演者フォロー
  async performer_follow ({ commit }, { api_path }) {
    commit('setIsSendingRequest', true)
    await axios.post(api_path,{})
    .then(res => {
      if (res.data.status != consts.API.STATUS_OK ) {
        commit('setIsSendingRequest', false)
        alert(res.data.message)
        commit('setFollowable')
        commit('setIsFollowing', false)
      } else {
        commit('setIsSendingRequest', false)
        commit('setUnFollowable')
        commit('setIsFollowing', true)
      }
    })
    .catch(e => {
      commit('setFollowable')
      alert("フォローに失敗しました")
    })
  },

  // 出演者フォロー解除
  async performer_un_follow ({ commit }, { api_path }) {
    commit('setIsSendingRequest', true)
    await axios.delete(api_path,{})
    .then(res => {
      if (res.data.status != consts.API.STATUS_OK ) {
        commit('setIsSendingRequest', false)
        commit('setUnFollowable')
        alert(res.data.message)
        commit('setIsFollowing', true)
      } else {
        commit('setIsSendingRequest', false)
        commit('setFollowable')
        commit('setIsFollowing', false)
      }
    })
    .catch(_ => {
      commit('setUnFollowable')
      alert("フォロー解除に失敗しました")
    })
  },

  // キュレーションページ情報を取得
  async getPerformerData ({ commit }, { api_path }) {
    commit('setDisplayProgress', true)
    await axios.get(api_path)
    .then(res => {
      commit('setPerformerData', res.data.data.data.performer)
      commit('setIsFollowing', res.data.data.data.performer.is_followed)
      commit('setMessagesLength', res.data.data.data.performer.meta.curation_site_articles_length)
      commit('setMusicLength', res.data.data.data.performer.meta.spotify_albums_length)
      commit('setDisplayProgress', false)
    })
  },

  // 出演者に紐づくMessageを取得
  async getMessages ({ commit }, { api_path, p, page, per }) {
    commit('setDisplayProgress', true)
    await axios.get(api_path + '?p=' + p + '&page=' + page + "&per=" + per)
    .then(res => {
      if (res.data.status != consts.API.STATUS_OK ) {
        alert(res.data.message);
        commit('setMessagesLength', 0)
        commit('setDisplayProgress', false)
      } else {
        commit('setMessages', res.data.data.data)
        commit('setMessagesLength', res.data.data.length)
        commit('setDisplayProgress', false)
      }
    })
  },

  // 出演者に紐づくMusicを取得
  async getMusic ({ commit }, { api_path, p, page, per }) {
    commit('setDisplayProgress', true)
    await axios.get(api_path + '?p=' + p + '&page=' + page + "&per=" + per)
    .then(res => {
      if (res.data.status != consts.API.STATUS_OK ) {
        alert(res.data.message);
        commit('setMusic', 0)
        commit('setDisplayProgress', false)
      } else {
        commit('setMusic', res.data.data.data)
        commit('setMusicLength', res.data.data.length)
        commit('setDisplayProgress', false)
      }
    })
  },

  // 表示する活動のジャンルを更新
  updateCurrentGenre ({commit}, payload) {
    commit('setCurrentGenre', payload)
  }
}


const mutations = {
  setCurrentGenre (state, payload) {
    state.currentGenre = payload
  },
  // eventsをstateに設定する
  setEvents (state, events) {
    for (var i in events) {
      state.items.push(events[i])
    }
  },
  // eventsをstateに設定する(takibi用)
  setEventsForCuration (state, events) {
    state.events = events
  },
  // 出演者に紐づく総イベント数
  setEventsCount (state, length) {
    state.length = length
  },
  // フォロー可能状態を設定
  setFollowable (state) {
    state.follow_status = consts.PERFORMER_FOLLOW_STATUS.FOLLOWABLE
  },
  // フォロー解除可能状態を設定
  setUnFollowable (state) {
    state.follow_status = consts.PERFORMER_FOLLOW_STATUS.UN_FOLLOWABLE
  },
  // 未ログイン状態を設定
  setNoLoggedin (state) {
    state.follow_status = consts.PERFORMER_FOLLOW_STATUS.NO_LOGGEDIN
  },
  // デフォルト状態を設定
  setDefault (state) {
    state.follow_status = consts.PERFORMER_FOLLOW_STATUS.DEFAULT
  },
  setPerformerData (state, payload) {
    state.performerData = payload
  },
  setMessages (state, payload) {
    state.messages = payload
  },
  setMessagesLength (state, length) {
    state.messagesLength = length
  },
  setMusic (state, payload) {
    state.musics = payload
  },
  setMusicLength (state, length) {
    state.musicLength = length
  },
  setIsFollowing (state, payload) {
    state.isFollowing = payload
  },
  setDisplayProgress (state, payload) {
    state.displayProgress = payload
  },
  setIsSendingRequest (state, payload) {
    state.isSendingRequest = payload
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
